import axios from 'axios';
import { debug } from '@/utils/logger';

const DEFAULT_MAX_RETRIES = 3;
const DEFAULT_INITIAL_DELAY_MS = 1500;

function getResponseStatus(err: unknown): number | undefined {
  if (axios.isAxiosError(err)) {
    return err.response?.status;
  }
  const withStatus = err as { response?: { status?: number }; status?: number } | null;
  return withStatus?.response?.status ?? withStatus?.status;
}

export async function retryOnRateLimit<T>(
  fn: () => Promise<T>,
  options?: { maxRetries?: number; initialDelayMs?: number; label?: string },
): Promise<T> {
  const maxRetries = options?.maxRetries ?? DEFAULT_MAX_RETRIES;
  let delayMs = options?.initialDelayMs ?? DEFAULT_INITIAL_DELAY_MS;
  const label = options?.label ?? 'retryOnRateLimit';

  let attempt = 0;
  while (true) {
    try {
      return await fn();
    } catch (err: unknown) {
      const status = getResponseStatus(err);
      if (status === 429 && attempt < maxRetries) {
        attempt += 1;
        debug(`[${label}] Rate limited (429), retry ${attempt}/${maxRetries} after ${delayMs}ms`);
        await new Promise((resolve) => setTimeout(resolve, delayMs));
        delayMs *= 2;
        continue;
      }
      throw err;
    }
  }
}
